import { PieGraph } from "@/components/graphs/PieGraph";
import styles from "./css/DualPieChart.module.css";
import { formatNumberWithCommas } from "@/utils/numbers";

const formatNumber = (num: number) => {
    // if (num >= 1e6) return `${(num / 1e6).toFixed(1).replace('.0', '')}M`;
    // if (num >= 1e3) return `${(num / 1e3).toFixed(1).replace('.0', '')}K`;
    return formatNumberWithCommas(num);
};

interface DualPieChartProps {
    data: {
        [year: string]: {
            [key: string]: number;
        };
    };
    colors: {
        [key: string]: string;
    };
    size?: "xsmall" | "small";
    years: [string, string]; // Tuple of two data keys to compare (backend keys)
    labels?: [string, string]; // Optional display labels (translated), falls back to years
    energyRating?: string;
}

export const DualPieChart: React.FC<DualPieChartProps> = ({
    data,
    colors,
    size = "small",
    years,
    labels,
    energyRating
}) => {
    const displayLabels: [string, string] = labels ?? years;
    return (
        <div className={styles.graphContent}>
            <div className={styles.legendContainer}>
                <div className={styles.legendWrapper}>
                    {Object.entries(colors).map(([name, color]) => (
                        <div key={name} className={styles.legendItem}>
                            <span 
                                className={styles.legendDot}
                                style={{ backgroundColor: color }}
                            />
                            <span className={styles.legendText}>
                                {name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
            
            <div className={styles.pieChartsContainer}>
                <div className={styles.pieChartWrapper}>
                {data.total && (
                        <div className={styles.totalValue}>
                            סה״כ: {formatNumber(data.total[years[1]])} MW
                        </div>
                    )}
                    <PieGraph 
                        data={data[years[1]]} 
                        colors={colors} 
                        size={size}
                        showLegend={false} 
                        year={displayLabels[1]}
                        valueDisplay={"number"}
                    />
                </div>
                <div className={styles.pieChartWrapper}>
                    {data.total && (
                        <div className={styles.totalValue}>
                            סה״כ: {formatNumber(data.total[years[0]])} MW
                        </div>
                    )}
                    <PieGraph 
                        data={data[years[0]]} 
                        colors={colors} 
                        size={size}
                        showLegend={false}
                        year={displayLabels[0]}
                        valueDisplay={"number"}
                    />
                </div>

            </div>
        </div>
    );
};